import { Card, Table, Modal, Button } from "react-bootstrap";
// import SearchIcon from '@material-ui/icons/Search';
import React, { useState } from "react";
import "./style/style.css"

const toolData = [
    {
      tool: "PIPL",
      input: "Linkedins or Emails",
      output: "Phone Nos.",
      description: `1) To extract Phone Numbers using Linkedins or Emails as input.
      2) Depending upon the quantity ample time is consumed, roughly for 300 output expect 3 hours to extract. 
      3) This tool has to be used only one at a time, hence has to be confirmed with others before uploading the data. 
      4) Expect 40% output, this may fluctuate depending upon availbility. 
      5) Always mention the file name as for which client you are working upon. 
      6) This is the only to tool to extract Phone numbers using email id.`
    },
    {
      tool: "GST",
      input: "Company Name with Pincodes/City",
      output: "GST Number and CIN Number",
      description: `1) To Extract the CIN Numbers & GST Numbers
      2) If the company is public limited or private limited we use it to get the cin numbers and the GST numbers.
      3) If the input is a Proprietor or Partnership firm then we get the GST numbers.
      4) Expect 85% output in the case of CIN Numbers and 70% in the case of GST numbers.
      5) Always mention the file name as for which client you are working upon. 
      6) The output time is around 1hr for 100 leads`      
    },
    {
      tool: "GST Scrapper Fast",
      input: "Company Name with Pincodes/City",
      output: "GST Number",
      description: `1) To extract the GST numbers of companies
      2) This tool is to get the output fast
      3) This tool doesn't works to get the CIN Numbers
      4) The output percentage is around 70%
      5) The time for 100 leads is 5-10mins`      
    },
    {
      tool: "Linkedin URL Fast",
      input:
        "*Personal Linkedin- Person Name+Designation+Company Name\n*Company Linkedin- Company Name",
      output: "Personal Linkedin\nCompany linkedin",
      description: `1) To get the Person Linkedin ID or Company Linkedin ID
      2) For Person Linkedin ID the input is Person Name with Designation and Company Name or the Input can be Person Name with Company Name
      3) For Company Linkedin ID the input is Company Name
      4) The output percentage is 90%
      5) The output time is 100 leads is 10mins`      
    },
    {
      tool: "Operia",
      input: "Company Linkedin",
      output: "HQ Address, Industry, Website & Employee Count",
      description: `1) To extract the companies basic details
      2) Basic details like Company Website, Industry, Employee Count & HQ Location
      3) To extract the data we need Company Linkedins
      4) The file breaks multiple times so we have to upload again and again to get the output
      5) This is the only tool in our server which gives us all the basic details
      6) The output time is undefined because we upload the files multiple times to get proper output`      
    },
    {
      tool: "Elastic Search",
      input:
        "*Phone number\n*Email\n*Society Name",
      output:
        "*Phone Number-Name and Email\n*Email- Name & Phone Number\n*Society Name- Name, Phone, Email, Address",
      description: `1) This tool is our database
      2) This tool is used to get the phone numbers, emails and address
      3) To get the Phones input is emails and we get the person name as well
      4) To get the Emails input is Phones and we the get the person name as well
      5) This tool is used if the imput is society name then the output is the person name, phone, email and address
      6) This tool works as a geolocator`        
    },
    {
      tool: "Company Website",
      input: "Company Names",
      output: "Websites",
      description: `1) To extract the websites of the companies
      2) Output is 65%
      3) The time for 100 leads is 1 hrs
      4) Its better to put file in batches of 500 leads to get a better and faster output`      
    },
    {
      tool: "MCA",
      input: "CIN Number",
      output: "Company name, address, email, Director Names & Founded Years",
      description: `1) To extract the company details of Private limited or LLCs
      2) The output percentage is 90%
      3) The time consumed for 100 leads is 1hr
      4) For better & faster output put it in batches of 500 leads
      5) This tool gives you the basic information of the companies starting from the email id associated to the Director's Name`
    },
    {
      tool: "Jobs Scrapper",
      input: "Naukri link or Indeed link",
      output: "To get the job links with job name and its description",
      description: `1) To extract the Job Links
      2) It's the tool that gives us the job description
      3) The maximum leads that it can process is 1000
      4) The output time is more than 1hr`      
    },
    {
      tool: "Startup India",
      input: "DPIIT Data",
      output: "Company name and DPIIT Number",
      description: `1) To extract the Startup that are registered in Government website
      2) This tool can't be stopped when it starts processing`      
    },
    {
      tool: "Map Result",
      input: "Query and Lat and Long of the location",
      output: "Company name, phone and address",
      description: `1) This tool is used the extract the data that is available on Google maps
      2) It gives us output of Mobile number, address and websites
      3) We do not get emails from this tool
      4) This tool is to get the companies data
      5) The latitude and longitude is the primary factor to get the output`
    },
    {
      tool: "QC Automation",
      input: "Delivery file",
      output: "Reviewed Filed",
      description: `1) This is the QC tool
      2) This works on the basis of the index we fill and the exclusion (if provided) is given properly
      3) We use the tool to increase the Quality of our deliveries as it checks all the errors that are there in the sheet and has different colour markings
      4) RED Means there is error BLUE means Duplicate and YELLOW means Excluded data`      
    },
    {
      tool: "Scrape Sellers",
      input: "Input Amazon.com product link",
      output: "Seller name and product name",
      description: `1) To extract the seller details
      2) This tool only works for Amazon.com
      3) This scrapes the data according to the product a seller has posted`      
    },
    {
      tool: "MCA filter",
      input: "",
      output: "",
      description: ""
    },
    {
      tool: "Emails & Phones",
      input: "Company websites",
      output: "Emails and Phones",
      description: `1) To extract the Emails and Phone Numbers that are available on websites
      2) The output time is 2-3 hrs for 100 leads`      
    },
    {
      tool: "Jobs Scrapper Bulk",
      input:
        "Same as Job Scrapper tool just we can add multiple links to scrape the jobs",
      output: "",
      description: ""
    },
    {
      tool: "Excel Sheet Combiner",
      input: "",
      output: "",
      description: `1) To combine multiple excel sheets
      2) Its important the headers should have the same templates`      
    },
    {
      tool: "Youtube Scrapper",
      input: "Requires keywords",
      output: "Video uploaded by names and their youtube page links and emails if available",
      description: `1) To extract the data of the people who upload video on Youtube
      2) The keywords are required to find the links of the videos`      
    },
    {
      tool: "Instagram Scrapper",
      input: "Username followers, Hastags Posts and Posts liker",
      output: "Instagram name and Instagram ID",
      description: `1) To extract the instagram id of the people for different use case
      2) To extract the instagram ID of the followers of posts by a certain Hashtag
      3) To extract the instagram ID of the likes of posts by post link
      4) We get the instagram ID and Instagram Names of the people`      
    }
  ];
  
function Search(props) {
  const [showModal, setShowModal] = useState(false);

  const handleIndexClick = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
        <div className="search">
            <Card className="shadow search_box">
                <input
                    className="search_box_input"
                    type="text"
                    placeholder="Search"
                    name="Search"
                    onChange={(e) => props.search_text(e.target.value)}
                />
            </Card>
            <div className="buttondiv">
                <button className="index_button" style={{height:"3rem",margin:"auto"}} onClick={handleIndexClick}>Index</button>
            </div>
            <Modal show={showModal} onHide={handleCloseModal} size="lg" dialogClassName="custom-modal">
        <Modal.Header closeButton>
          <Modal.Title>OPS Tool Index</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>OPS Tool</th>
                <th>INPUT</th>
                <th>OUTPUT</th>
                <th>DESCRIPTION</th>
              </tr>
            </thead>
            <tbody>
              {toolData.map((data, index) => (
                <tr key={index}>
                  <td>{data.tool}</td>
                  <td>{data.input}</td>
                  <td>{data.output}</td>
                  <td style={{ whiteSpace: 'pre-line' }}>{data.description}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
        </div>
    )
   }
export default Search